import lunr from 'lunr';
import { createSelector } from 'reselect';

import { APICallStatus } from '../../design-system/types';
import { RootState } from '../../shared/redux/types';

import { MessageTemplate, NormalizedMessageTemplates, MessageTemplateId } from './types';

export const getAllMessageTemplates = (state: RootState): NormalizedMessageTemplates =>
    state.entities.messageTemplate;

export const getAllMessageTemplatesArray = (state: RootState): MessageTemplate[] =>
    Object.values(state.entities.messageTemplate);

export const getMessageTemplateStatus = (state: RootState): APICallStatus | undefined =>
    state.status.messageTemplate.get;

export const patchMessageTemplateStatus = (
    state: RootState,
    messageTemplateId: MessageTemplateId,
): APICallStatus => (state.status.messageTemplate.patch || {})[messageTemplateId];

export const postMessageTemplateStatus = (state: RootState): APICallStatus | undefined =>
    state.status.messageTemplate.post;

export const getMessageTemplateById = (
    state: RootState,
    messageTemplateId: MessageTemplateId,
): MessageTemplate => state.entities.messageTemplate[messageTemplateId];

export const getMessageTemplateSearchIndex = createSelector(
    getAllMessageTemplatesArray,
    (messageTemplates) => {
        const items = messageTemplates.map((messageTemplate) => ({
            id: messageTemplate.id,
            title: messageTemplate.title,
        }));
        const searchIndex = lunr(function (builder) {
            builder.ref('id');
            builder.field('title');
            builder.pipeline.remove(lunr.stemmer);
            builder.pipeline.remove(lunr.stopWordFilter);
            builder.searchPipeline.remove(lunr.stemmer);
            builder.searchPipeline.remove(lunr.stopWordFilter);
            items.forEach((item) => {
                builder.add(item);
            });
        });
        return searchIndex;
    },
);
